"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("@cdo/apps/utils");
var responseValidators_1 = require("../responseValidators");
var HttpClient_1 = require("@cdo/apps/util/HttpClient");
var Lab2Registry_1 = __importDefault(require("../Lab2Registry"));
var reload = require('@cdo/apps/utils').reload;
var ProjectManager = /** @class */ (function () {
    function ProjectManager(sourcesStore, channelsStore, channelId, reduceChannelUpdates, metricsReporter) {
        if (metricsReporter === void 0) { metricsReporter = Lab2Registry_1.default.getInstance().getMetricsReporter(); }
        this.nextSaveTime = null;
        this.saveInterval = 30 * 1000; // 30 seconds
        this.saveInProgress = false;
        this.saveQueued = false;
        this.saveSuccessListeners = [];
        this.saveNoopListeners = [];
        this.saveFailListeners = [];
        this.saveStartListeners = [];
        this.destroyed = false;
        this.channelId = channelId;
        this.sourcesStore = sourcesStore;
        this.channelsStore = channelsStore;
        this.reduceChannelUpdates = reduceChannelUpdates;
        this.initialSaveComplete = false;
        this.forceReloading = false;
        this.metricsReporter = metricsReporter;
    }
    ProjectManager.prototype.getChannelId = function () {
        return this.channelId;
    };
    // Load the project from the sources and channels store.
    ProjectManager.prototype.load = function () {
        return __awaiter(this, void 0, Promise, function () {
            var sources, error_1, channel, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.destroyed) {
                            this.throwErrorIfDestroyed('load');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sourcesStore.load(this.channelId)];
                    case 2:
                        sources = _a.sent();
                        this.lastSource = JSON.stringify(sources);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        // If there was a validation error or sourceResponse is a 404 (not found),
                        // we still want to load the channel. In the case of a validation error,
                        // we will default to empty sources. Source can return not found if the project
                        // is new. If neither of these cases, throw the error.
                        if (error_1 instanceof responseValidators_1.ValidationError) {
                            this.metricsReporter.logWarning("Error validating sources (".concat(error_1.message, "). Defaulting to empty sources."));
                        }
                        else if (error_1 instanceof HttpClient_1.NetworkError &&
                            error_1.response.status === 404) {
                            // This is expected if the project is new. Default to empty sources.
                        }
                        else {
                            throw new Error('Error loading sources', { cause: error_1 });
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.channelsStore.load(this.channelId)];
                    case 5:
                        channel = _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _a.sent();
                        throw new Error('Error loading channel', { cause: error_2 });
                    case 7:
                        this.lastChannel = channel;
                        return [2 /*return*/, { sources: sources, channel: channel }];
                }
            });
        });
    };
    ProjectManager.prototype.hasUnsavedChanges = function () {
        return this.sourceChanged();
    };
    // Shut down this project manager. All we do here is clear the existing
    // timeout, if it exists.
    ProjectManager.prototype.destroy = function () {
        this.resetSaveState();
        this.destroyed = true;
    };
    // Save any enqueued unsaved changes, then destroy the project manager.
    ProjectManager.prototype.cleanUp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.sourcesToSave) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.save(this.sourcesToSave, true)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.destroy();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Enqueue a save to happen in the next saveInterval, unless a force save is requested.
     * If a save is already enqueued, update this.sourceToSave with the given source.
     * @param sources ProjectSources: the source to save.
     * @param forceSave boolean: if the save should happen immediately
     * @returns a promise that resolves to a Response. If the save is successful, the response
     * will be empty, otherwise it will contain failure information.
     */
    ProjectManager.prototype.save = function (sources, forceSave) {
        if (forceSave === void 0) { forceSave = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.destroyed) {
                            // If we have already been destroyed, don't attempt to save.
                            this.resetSaveState();
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        this.sourcesToSave = sources;
                        return [4 /*yield*/, this.enqueueSaveOrSave(forceSave)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Try to force save with the last sourcesToSave, if it exists.
     * This is used to flush out any remaining enqueued saves.
     * @returns  a promise that resolves to a Response. If the save is successful, the response
     * will be empty, otherwise it will contain failure information.
     */
    ProjectManager.prototype.flushSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.destroyed) {
                            // If we have already been destroyed, don't attempt to save.
                            this.resetSaveState();
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        return [4 /*yield*/, this.enqueueSaveOrSave(true)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Rename the current project. Default to saving immediately.
     * @param name new name for the project.
     * @param forceSave Whether or not to save immediately. Default to true, because
     * renames are done in response to a user action.
     * @returns a promise that resolves to a Response. If the rename is successful, the response
     * will be empty, otherwise it will contain failure information.
     */
    ProjectManager.prototype.rename = function (name, forceSave) {
        if (forceSave === void 0) { forceSave = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.destroyed || !this.lastChannel) {
                            // If we have already been destroyed or the channel does not exist,
                            // don't attempt to rename.
                            return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                        }
                        if (!this.channelToSave) {
                            this.channelToSave = JSON.parse(JSON.stringify(this.lastChannel));
                        }
                        this.channelToSave.name = name;
                        return [4 /*yield*/, this.enqueueSaveOrSave(forceSave)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a share URL for the current project.
     *
     * Share URLs can vary by application environment and project type.  For most
     * project types the share URL is the same as the project edit and view URLs,
     * but has no action appended to the project's channel ID. Weblab is a special
     * case right now, because it shares projects to codeprojects.org.
     *
     * This function depends on the document location to determine the current
     * application environment.
     *
     * @returns {string} Fully-qualified share URL for the current project.
     */
    ProjectManager.prototype.getShareUrl = function () {
        if (!this.lastChannel || !this.lastChannel.projectType) {
            return null;
        }
        var location = (0, utils_1.currentLocation)();
        // This will not work for web lab, but we will likely not move web lab to use ProjectManager.
        return (location.origin +
            '/projects/' +
            this.lastChannel.projectType +
            '/' +
            this.channelId);
    };
    ProjectManager.prototype.redirectToRemix = function () {
        this.throwErrorIfDestroyed('redirectToRemix');
        if (!this.lastChannel || !this.lastChannel.projectType) {
            this.logAndThrowError('Cannot remix without channel');
            return;
        }
        this.channelsStore.redirectToRemix(this.lastChannel);
    };
    /**
     * Publish the current channel.
     */
    ProjectManager.prototype.publish = function () {
        this.publishHelper(true);
    };
    /**
     * Unpublish the current channel.
     */
    ProjectManager.prototype.unpublish = function () {
        this.publishHelper(false);
    };
    ProjectManager.prototype.addSaveSuccessListener = function (listener) {
        this.saveSuccessListeners.push(listener);
    };
    ProjectManager.prototype.addSaveNoopListener = function (listener) {
        this.saveNoopListeners.push(listener);
    };
    ProjectManager.prototype.addSaveFailListener = function (listener) {
        this.saveFailListeners.push(listener);
    };
    ProjectManager.prototype.addSaveStartListener = function (listener) {
        this.saveStartListeners.push(listener);
    };
    ProjectManager.prototype.isForceReloading = function () {
        return this.forceReloading;
    };
    /**
     * Helper function to save a project, called either after a timeout or directly by save().
     * On a save, we check if there are unsaved changes to the source or channel.
     * If there are none, we can skip the save. If only the channel changed, we can
     * skip saving the source.
     * Only if the source save succeeds do we update the channel, as the
     * channel is metadata about the project and we don't want to save it unless the source
     * save succeeded.
     * @returns a Promise<void> that resolves when the save is complete or when the save fails.
     * Listeners are notified of save status throughout the process.
     */
    ProjectManager.prototype.saveHelper = function () {
        return __awaiter(this, void 0, Promise, function () {
            var sourceChanged, channelChanged, error_3, channelResponse, error_4, channelSaveResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // We can't save without a last channel or last source.
                        // We also know we don't need to save if we don't have sources to save
                        // or a channel to save.
                        // We also cannot save if the user is not the owner of this project.
                        if (!this.lastChannel ||
                            !this.lastChannel.isOwner ||
                            !(this.sourcesToSave || this.channelToSave)) {
                            this.executeSaveNoopListeners(this.lastChannel);
                            return [2 /*return*/];
                        }
                        this.resetSaveState();
                        this.saveInProgress = true;
                        this.nextSaveTime = Date.now() + this.saveInterval;
                        this.executeSaveStartListeners();
                        sourceChanged = this.sourceChanged();
                        channelChanged = this.channelChanged();
                        // If neither source nor channel has actually changed, no need to save again.
                        if (!sourceChanged && !channelChanged) {
                            this.saveInProgress = false;
                            this.executeSaveNoopListeners(this.lastChannel);
                            return [2 /*return*/];
                        }
                        if (!(this.sourcesToSave && sourceChanged)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sourcesStore.save(this.channelId, this.sourcesToSave)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.onSaveFail('Error saving sources', error_3);
                        return [2 /*return*/];
                    case 4:
                        this.lastSource = JSON.stringify(this.sourcesToSave);
                        _a.label = 5;
                    case 5:
                        if (!(!this.reduceChannelUpdates || !this.initialSaveComplete)) return [3 /*break*/, 11];
                        // As long as we are not in emergency mode, always save the channel,
                        // as either the channel has changed and/or the source changed.
                        // Even if only the source changed, we still update the channel to modify the last
                        // updated time.
                        this.channelToSave || (this.channelToSave = this.lastChannel);
                        channelResponse = void 0;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this.channelsStore.save(this.channelToSave)];
                    case 7:
                        channelResponse = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        error_4 = _a.sent();
                        this.onSaveFail('Error saving channel', error_4);
                        return [2 /*return*/];
                    case 9: return [4 /*yield*/, channelResponse.json()];
                    case 10:
                        channelSaveResponse = _a.sent();
                        this.lastChannel = channelSaveResponse;
                        _a.label = 11;
                    case 11:
                        this.saveInProgress = false;
                        this.channelToSave = undefined;
                        this.executeSaveSuccessListeners(this.lastChannel);
                        this.initialSaveComplete = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectManager.prototype.onSaveFail = function (errorMessage, error) {
        this.saveInProgress = false;
        this.executeSaveFailListeners(error);
        if (error.message.includes('409')) {
            // If this is a conflict, we need to reload the page.
            // We set forceReloading to true so the client can skip
            // showing the user a dialog before reload.
            this.forceReloading = true;
            this.metricsReporter.logWarning('Conflict on save, reloading page');
            reload();
        }
        else {
            // Otherwise, we log the error.
            this.metricsReporter.logError(errorMessage, error);
        }
    };
    ProjectManager.prototype.canSave = function (forceSave) {
        if (this.saveInProgress) {
            return false;
        }
        else if (forceSave) {
            // If this is a force save, don't wait until the next save time.
            return true;
        }
        else if (this.nextSaveTime) {
            return this.nextSaveTime <= Date.now();
        }
        return true;
    };
    // Check if we can save immediately. If a save is in progress, we must wait. Otherwise,
    // if forceSave is true or it has been at least 30 seconds since our last save,
    // initiate a save.
    // If we cannot save now, enqueue a save if one has not already been enqueued and
    // return a noop response.
    ProjectManager.prototype.enqueueSaveOrSave = function (forceSave) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.canSave(forceSave)) return [3 /*break*/, 1];
                        if (!this.saveQueued) {
                            // enqueue a save
                            this.saveQueued = true;
                            this.currentTimeoutId = window.setTimeout(function () {
                                _this.saveHelper();
                            }, this.nextSaveTime ? this.nextSaveTime - Date.now() : this.saveInterval);
                        }
                        return [2 /*return*/, this.getNoopResponseAndSendSaveNoopEvent()];
                    case 1: return [4 /*yield*/, this.saveHelper()];
                    case 2: 
                    // if we can save immediately, initiate a save now. This is an async
                    // request.
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProjectManager.prototype.getNoopResponse = function () {
        return new Response(null, { status: 304 });
    };
    ProjectManager.prototype.getNoopResponseAndSendSaveNoopEvent = function () {
        var noopResponse = this.getNoopResponse();
        this.executeSaveNoopListeners(this.lastChannel);
        return noopResponse;
    };
    ProjectManager.prototype.sourceChanged = function () {
        if (!this.sourcesToSave) {
            return false;
        }
        return this.lastSource !== JSON.stringify(this.sourcesToSave);
    };
    ProjectManager.prototype.channelChanged = function () {
        // If we don't have a channel to save or a last channel, we can't compare.
        // It isn't possible to have a channelToSave without a lastChannel,
        // as we create channelToSave from lastChannel.
        if (!this.channelToSave || !this.lastChannel) {
            return false;
        }
        return (JSON.stringify(this.lastChannel) !== JSON.stringify(this.channelToSave));
    };
    ProjectManager.prototype.resetSaveState = function () {
        if (this.currentTimeoutId !== undefined) {
            window.clearTimeout(this.currentTimeoutId);
            this.currentTimeoutId = undefined;
        }
        this.saveQueued = false;
    };
    ProjectManager.prototype.throwErrorIfDestroyed = function (actionName) {
        if (this.destroyed) {
            this.logAndThrowError("Tried to ".concat(actionName, ", but the Project Manager was destroyed."));
        }
    };
    ProjectManager.prototype.logAndThrowError = function (errorMessage) {
        var error = new Error(errorMessage);
        this.metricsReporter.logError(errorMessage, error);
        throw error;
    };
    /**
     * Helper for publish and unpublish methods, since they are so similar.
     * Either publishes or unpublishes lastChannel, depending on the publish parameter.
     * If this ProjectManager has been destroyed, or we're missing a channel, this method
     * will throw an error.
     * @param publish true if we should publish, false is we should unpublish
     * @returns a Promise that resolves when the publish/unpublish is complete
     */
    ProjectManager.prototype.publishHelper = function (publish) {
        return __awaiter(this, void 0, void 0, function () {
            var actionType;
            return __generator(this, function (_a) {
                actionType = publish ? 'publish' : 'unpublish';
                this.throwErrorIfDestroyed(actionType);
                if (!this.lastChannel || !this.lastChannel.projectType) {
                    this.logAndThrowError("Cannot ".concat(actionType, " without channel"));
                    return [2 /*return*/];
                }
                if (publish) {
                    return [2 /*return*/, this.channelsStore.publish(this.lastChannel)];
                }
                else {
                    return [2 /*return*/, this.channelsStore.unpublish(this.lastChannel)];
                }
                return [2 /*return*/];
            });
        });
    };
    // LISTENERS
    ProjectManager.prototype.executeSaveSuccessListeners = function (channel) {
        this.saveSuccessListeners.forEach(function (listener) { return listener(channel); });
    };
    ProjectManager.prototype.executeSaveNoopListeners = function (channel) {
        this.saveNoopListeners.forEach(function (listener) { return listener(channel); });
    };
    ProjectManager.prototype.executeSaveFailListeners = function (error) {
        this.saveFailListeners.forEach(function (listener) { return listener(error); });
    };
    ProjectManager.prototype.executeSaveStartListeners = function () {
        this.saveStartListeners.forEach(function (listener) { return listener(); });
    };
    return ProjectManager;
}());
exports.default = ProjectManager;
